module.exports = __webpack_public_path__ + "796f09aa7173c330e30e11c61cfc3ca0.pdf";